import * as React from 'react';
import { SvgIcon } from '@mildang/mui';
import type { SvgIconProps } from '@mildang/mui';

const SlashIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fill="currentColor" d="m14.477 2.26 1.88.683-6.84 18.794-1.88-.684z" />
  </SvgIcon>
);

export default SlashIcon;
